const Key = require('common/domain/value/key');
const Backbone = require('backbone');
const _ = require('underscore');
const UserEmailCollection = require('common/domain/collection/user-email');

/**
 * @exports models/member-model
 */
module.exports = Backbone.Model.extend({
    /**
     * Backbone.Model を extend した UserModel を定義する
     */
    defaults: {
        name: '',
        image_url: null,
        image_blob: null,
        language: 'ja',
        mail_address_list: null, // null の場合はサーバー側で出力しない設定になっている
        timezone: '+09:00'
    },

    validation: {
        name: [
            {
                required: true,
                msg: 'input.user.name.validation.required'
            },
            // {
            //     pattern: /^\s*\w+(?:\s+\w+)*\s*$/,
            //     msg: 'input.user.name.validation.invalid'
            // }
        ]
    },

    initialize: function() {
        const emails = this.get('mail_address_list');
        if(emails != null) {
            this.set({_emails: new UserEmailCollection(emails)});
        }
    },

    getKey: function() {
        return new Key(`User:${this.get('id')}`);
    },

    getName: function() {
        return this.get('name');
    },

    getImageURL: function() {
        return this.get('image_url');
    },

    getEmails: function() {
        return this.get('_emails');
    },

    getTimeLocale: function() {
        return this.getLocale();
    },

    getLocale: function() {
        return this.get('language');
    },

    isSiteAdmin: function() {
        return this.get('site_admin');
    },

    isLeviiUser: function () {
        if (!this.getEmails()) {
            return false;
        }
        return this.getEmails().getPrimary().isLeviiDomain();
    },

    isSuspended: function() {
        return this.get('suspended');
    },

    hasAdminPermissions: function() {
        return this.get('admin_permissions');
    },

    hasAdminPermission: function(permissionName) {
        return this.hasAdminPermissions()[permissionName];
    },

    hasFeedbackAdminPermission: function() {
        return this.hasAdminPermission('admin:feedback:all');
    },

    editableAttributes: function() {
        var json = this.toJSON();
        delete json['id'];
        delete json['created_at'];
        delete json['updated_at'];
        delete json['site_admin'];
        return json;
    }
}, {
    languages: [
        {
            "label": "日本語 (Japanese)",
            "value": "ja"
        },
        {
            "label": "English",
            "value": "en"
        }
    ]
});



// WEBPACK FOOTER //
// ./common/domain/entity/user.js